// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-panel[data-v-d84a1a68]{padding:0 20px 10px 16px;border-bottom:1px solid #d3d3d3;font-size:12px}.text-panel__actions[data-v-d84a1a68]{display:flex}.text-panel__actions[data-v-d84a1a68]>:not(:first-child){margin-left:10px}.text-panel__title[data-v-d84a1a68]{padding:10px 0;font-size:12px}", ""]);
// Exports
module.exports = exports;
